import gql from 'graphql-tag';
import apollo from 'src/features/apolloCustomer';
import i18n from 'src/features/i18n';

const mutation = gql`
mutation PairAccount($authId: String!, $token: String!){
  tokenMergeAccount(authId: $authId, token: $token) {
    id
    identified
    firstName
    lastName
    description
    accounts {
      id
      provider
      providerId
    }
  }
}`;

function parseAccount(item) {
  return {
    id: item.id,
    title: item.providerId,
    type: item.provider,
  };
}

function parseCustomer(item) {
  return {
    id: item.id,
    title: item.firstName,
    firstName: item.firstName,
    lastName: item.lastName,
    description: item.description,
    identified: !!item.identified,
    accounts: (item.accounts && item.accounts.map((res) => parseAccount(res))) || [],
  };
}

function pairAccount(authId, token) {
  return apollo.client.mutate({
    variables: {
      authId,
      token,
    },
    mutation,
  }).then((res) => parseCustomer(res.data.tokenMergeAccount))
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].message;
        throw i18n.t(errors);
      } else {
        throw err;
      }
    });
}

export default pairAccount;
